module.exports = __webpack_public_path__ + "img/Step2.50e7951c.png";